const variantTypes = [
  {
    type: 'kenburns',
    values: ['kenburnsTop', 'kenburnsBottom', 'kenburnsLeft', 'kenburnsRight']
  },
  {
    type: 'pan',
    values: ['panTop', 'panBottom', 'panLeft', 'panRight']
  },
  {
    type: 'color change',
    values: ['color2x', 'color3x', 'color4x', 'color5x']
  }
];

export default variantTypes;
